import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackNotAlonePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-time-dedication')
  }

  return (
    <FeedbackPage
      emoji="🌱"
      heading={t('pages.onboarding.feedbackNotAlone.heading')}
      text={t('pages.onboarding.feedbackNotAlone.text')}
      onSubmit={handleSubmit}
    />
  )
}
